import * as leaseHandoverTypes from 'constants/enums/leaseHandoverTypes'

export default {
  [leaseHandoverTypes.STANDARD]: 'Standardní',
  [leaseHandoverTypes.NON_STANDARD]: 'Nestandardní',
}
